import script from "./BalancesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalancesList.vue?vue&type=script&setup=true&lang=ts"

import "./BalancesList.vue?vue&type=style&index=0&id=367a5998&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367a5998"]])

export default __exports__